import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/browser'
import MainContent from './MainContent'
import { GeneralAppStorageContextProvider } from './app/GeneralAppStorageContext'
import LookupContextProvider from './app/LookupContext'
import { PermissionsProvider } from './app/PermissionsContext'
import { RoleIndicatorRefProvider } from './app/RoleIndicatorRefContext'
import Spinner from './app/Spinner'
import { PageTitleProvider } from './app/PageTitleContext'
import { useEventCollectorInstall, useReportModal } from '../hooks/useEventCapture'
import { createSentryAdapter } from '../util/event-capture/sentry-adapter'
import ReportModal from './event-capture/ReportModal'

const submitToSentry = createSentryAdapter(Sentry)

function ReportModalTrigger() {
  useEventCollectorInstall()
  const { isOpen, triggerMessage, closeModal } = useReportModal()
  return isOpen ? (
    <ReportModal onClose={closeModal} onSubmit={(report) => submitToSentry({ ...report, message: triggerMessage })} />
  ) : null
}

export default function App() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('app.title', 'Data Management Console')
  }, [t])

  return (
    <PermissionsProvider>
      <LookupContextProvider>
        <GeneralAppStorageContextProvider>
          <RoleIndicatorRefProvider>
            <Spinner />
            <ReportModalTrigger />
            <PageTitleProvider>
              <MainContent />
            </PageTitleProvider>
          </RoleIndicatorRefProvider>
        </GeneralAppStorageContextProvider>
      </LookupContextProvider>
    </PermissionsProvider>
  )
}
